import React from 'react';
import { Box, Skeleton } from '@chakra-ui/react';


export default function AppRouteSkeleton() {
  return (
    <Box
      data-testid="app-route-skeleton"
      minH="100dvh"
      bg="#08111f"
      px={{ base: 5, md: 10 }}
      py={{ base: 8, md: 12 }}
    >
      <Box
        minH={{ base: 'calc(100dvh - 64px)', md: 'calc(100dvh - 96px)' }}
        maxW="1180px"
        mx="auto"
        display="grid"
        gridTemplateColumns={{ base: '1fr', lg: 'minmax(0, 1fr) 440px' }}
        alignItems="center"
        gap={{ base: 8, lg: 20 }}
      >
        <Box display={{ base: 'none', lg: 'block' }}>
          <Skeleton startColor="whiteAlpha.100" endColor="whiteAlpha.200" h="22px" w="150px" mb={8} />
          <Skeleton startColor="whiteAlpha.100" endColor="whiteAlpha.200" h="52px" w="78%" mb={4} />
          <Skeleton startColor="whiteAlpha.100" endColor="whiteAlpha.200" h="20px" w="62%" />
        </Box>
        <Box w="100%" maxW="440px" mx="auto">
          <Skeleton startColor="whiteAlpha.100" endColor="whiteAlpha.200" h="34px" w="58%" mb={4} />
          <Skeleton startColor="whiteAlpha.100" endColor="whiteAlpha.200" h="14px" w="88%" mb={8} />
          <Skeleton startColor="whiteAlpha.100" endColor="whiteAlpha.200" h="52px" w="100%" mb={4} borderRadius="14px" />
          <Skeleton startColor="whiteAlpha.100" endColor="whiteAlpha.200" h="52px" w="100%" mb={5} borderRadius="14px" />
          <Skeleton startColor="whiteAlpha.100" endColor="whiteAlpha.200" h="52px" w="100%" borderRadius="16px" />
        </Box>
      </Box>
    </Box>
  );
}
